import { Column } from "../objects/column";

export const DEFAULT_COLUMN: Column[] = [{
    label: 'flight',
    field_name: 'FLIGHT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'pnr-number',
    field_name: 'PNR_NUMBER',
    checked: true,
    order_by: 'pnr_number',
    fixed_width: false,
    last_updated: false
}, {
    label: 'airline',
    field_name: 'AIRLINE',
    checked: true,
    order_by: 'source__commercial_name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'departure-date',
    field_name: 'START_DATE',
    checked: true,
    order_by: 'start_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'return-date',
    field_name: 'END_DATE',
    checked: true,
    order_by: 'end_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'purchase-price-adult-including-tax',
    field_name: 'PURCHASE_PRICE_INCLUDING_TAX',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'selling-price-adult-including-tax',
    field_name: 'SELLING_PRICE_INCLUDING_TAX',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'stock',
    field_name: 'STOCK',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'remaining-stock',
    field_name: 'REMAINING_STOCK',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'pnr-duration',
    field_name: 'PNR_DURATION',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'activated',
    field_name: 'IS_ACTIVE',
    checked: true,
    order_by: 'is_active',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];

export const PATHING_COLUMN: Column[] = [{
    label: 'flight',
    field_name: 'FLIGHT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'airline',
    field_name: 'AIRLINE',
    checked: true,
    order_by: 'source__commercial_name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'departure-date',
    field_name: 'START_DATE',
    checked: true,
    order_by: 'start_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'return-date',
    field_name: 'END_DATE',
    checked: true,
    order_by: 'end_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'purchase-price-adult-including-tax',
    field_name: 'PURCHASE_PRICE_INCLUDING_TAX',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'selling-price-adult-including-tax',
    field_name: 'SELLING_PRICE_INCLUDING_TAX',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'stock',
    field_name: 'STOCK',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'pnr-duration',
    field_name: 'PNR_DURATION',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false
}];
